export default "__VITE_ASSET__CD2Lfjk2__"